module.exports = import("/finance-insight/assets/remoteEntry.js");